// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BETypeElement } from './BETypeElement';
import { EnumDTPType } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/EnumDTPType';
import { EnumHTTPMethod } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/EnumHTTPMethod';
import { EnumNetworkProtocol } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/EnumNetworkProtocol';
import { BEComponent } from './BEComponent';
import { BEServiceAction } from './BEServiceAction';
import { ESParameter } from './ESParameter';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { BEExternalServiceExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/EntityModel/BEExternalServiceExtend';
/**
 * 外部服务 实体类
 * 引用的外部服务
 */
export class BEExternalService extends BETypeElement {
  /** 返回数据类型 : 返回数据类型，无返回使用void */
  private _returnDataType: EnumDataType;

  /** 设置：返回数据类型 */
  public get returnDataType() {
    return this._returnDataType;
  }

  /** 获取：返回数据类型 */
  public set returnDataType(value: EnumDataType) {
    this._returnDataType = value;
  }

  /** 返回引用类型 : 返回值引用类型，当数据类型为引用类型时有效 */
  private _returnReferenceType: string;

  /** 设置：返回引用类型 */
  public get returnReferenceType() {
    return this._returnReferenceType;
  }

  /** 获取：返回引用类型 */
  public set returnReferenceType(value: string) {
    this._returnReferenceType = value;
  }

  /** 返回值描述 : 返回值描述 */
  private _returnDescription: string;

  /** 设置：返回值描述 */
  public get returnDescription() {
    return this._returnDescription;
  }

  /** 获取：返回值描述 */
  public set returnDescription(value: string) {
    this._returnDescription = value;
  }

  /** 是否是集合 : 返回值是否是集合 */
  private _returnIsCollection: boolean;

  /** 设置：是否是集合 */
  public get returnIsCollection() {
    return this._returnIsCollection;
  }

  /** 获取：是否是集合 */
  public set returnIsCollection(value: boolean) {
    this._returnIsCollection = value;
  }

  /** 是否分页 : 返回值是否是否分页 */
  private _returnIsPaged: boolean;

  /** 设置：是否分页 */
  public get returnIsPaged() {
    return this._returnIsPaged;
  }

  /** 获取：是否分页 */
  public set returnIsPaged(value: boolean) {
    this._returnIsPaged = value;
  }

  /** 服务地址 : 不含协议名，域名以及微服务名称，也不含操作名称 。 */
  private _serviceUrl: string;

  /** 设置：服务地址 */
  public get serviceUrl() {
    return this._serviceUrl;
  }

  /** 获取：服务地址 */
  public set serviceUrl(value: string) {
    this._serviceUrl = value;
  }

  /** 服务名称 : 微服务注册的服务名称，模型使用应用名 */
  private _serviceName: string;

  /** 设置：服务名称 */
  public get serviceName() {
    return this._serviceName;
  }

  /** 获取：服务名称 */
  public set serviceName(value: string) {
    this._serviceName = value;
  }

  /** 方法 : 服务的方法 */
  private _action: string;

  /** 设置：方法 */
  public get action() {
    return this._action;
  }

  /** 获取：方法 */
  public set action(value: string) {
    this._action = value;
  }

  /** 支持分布式事务 : 是否支持分布式事务 */
  private _enableDistributeTransaction: boolean;

  /** 设置：支持分布式事务 */
  public get enableDistributeTransaction() {
    return this._enableDistributeTransaction;
  }

  /** 获取：支持分布式事务 */
  public set enableDistributeTransaction(value: boolean) {
    this._enableDistributeTransaction = value;
  }

  /** 分布式事务协议 : 分布式事务协议 */
  private _dTPType: EnumDTPType;

  /** 设置：分布式事务协议 */
  public get dTPType() {
    return this._dTPType;
  }

  /** 获取：分布式事务协议 */
  public set dTPType(value: EnumDTPType) {
    this._dTPType = value;
  }

  /** HTTP谓词 : 调用外部服务时的HTTP谓词 */
  private _httpMethod: EnumHTTPMethod;

  /** 设置：HTTP谓词 */
  public get httpMethod() {
    return this._httpMethod;
  }

  /** 获取：HTTP谓词 */
  public set httpMethod(value: EnumHTTPMethod) {
    this._httpMethod = value;
  }

  /** 网络协议 : 调用外部服务时的网络协议 */
  private _networkProtocol: EnumNetworkProtocol;

  /** 设置：网络协议 */
  public get networkProtocol() {
    return this._networkProtocol;
  }

  /** 获取：网络协议 */
  public set networkProtocol(value: EnumNetworkProtocol) {
    this._networkProtocol = value;
  }

  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: BEComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: BEComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 服务操作 */
  private _serviceActions: Array<BEServiceAction>;

  /** 获取：服务操作 */
  public get serviceActions() {
    return this._serviceActions;
  }

  /** 设置：服务操作 */
  public set serviceActions(value: Array<BEServiceAction>) {
    this._serviceActions = value;
  }

  /** 参数 */
  private _parameters: Array<ESParameter>;

  /** 获取：参数 */
  public get parameters() {
    return this._parameters;
  }

  /** 设置：参数 */
  public set parameters(value: Array<ESParameter>) {
    this._parameters = value;
  }

  constructor() {
    super();
    BEExternalServiceExtend.Init(this);
    this._returnDataType = EnumDataType.String;
    this._returnReferenceType = '';
    this._returnDescription = '';
    this._returnIsCollection = false;
    this._returnIsPaged = false;
    this._serviceUrl = '';
    this._serviceName = '';
    this._action = '';
    this._enableDistributeTransaction = false;
    this._dTPType = EnumDTPType.TCC;
    this._httpMethod = EnumHTTPMethod.GET;
    this._networkProtocol = EnumNetworkProtocol.HTTPS;
    this._component_ID = '';
    this._component = null;
    this._serviceActions = new Array<BEServiceAction>();
    this._parameters = new Array<ESParameter>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BEExternalService, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.returnDataType = element.returnDataType;
      this.returnReferenceType = element.returnReferenceType;
      this.returnDescription = element.returnDescription;
      this.returnIsCollection = element.returnIsCollection;
      this.returnIsPaged = element.returnIsPaged;
      this.serviceUrl = element.serviceUrl;
      this.serviceName = element.serviceName;
      this.action = element.action;
      this.enableDistributeTransaction = element.enableDistributeTransaction;
      this.dTPType = element.dTPType;
      this.httpMethod = element.httpMethod;
      this.networkProtocol = element.networkProtocol;
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.returnDataType = json.ReturnDataType as EnumDataType;
    this.returnReferenceType = json.ReturnReferenceType;
    this.returnDescription = json.ReturnDescription;
    this.returnIsCollection = json.ReturnIsCollection;
    this.returnIsPaged = json.ReturnIsPaged;
    this.serviceUrl = json.ServiceUrl;
    this.serviceName = json.ServiceName;
    this.action = json.Action;
    this.enableDistributeTransaction = json.EnableDistributeTransaction;
    this.dTPType = json.DTPType as EnumDTPType;
    this.httpMethod = json.HttpMethod as EnumHTTPMethod;
    this.networkProtocol = json.NetworkProtocol as EnumNetworkProtocol;
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = BEComponent.Create(json.Component);
    // }
    if (json.ServiceActions && json.ServiceActions.length > 0) {
      json.ServiceActions.forEach((element: any) => {
        const bEServiceAction = BEServiceAction.Create(element);
        // bEServiceAction.externalService = this;
        this.serviceActions.push(bEServiceAction);
      });
    }
    if (json.Parameters && json.Parameters.length > 0) {
      json.Parameters.forEach((element: any) => {
        const eSParameter = ESParameter.Create(element);
        // eSParameter.externalService = this;
        this.parameters.push(eSParameter);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.ReturnDataType = this.returnDataType;
    json.ReturnReferenceType = this.returnReferenceType;
    json.ReturnDescription = this.returnDescription;
    json.ReturnIsCollection = this.returnIsCollection;
    json.ReturnIsPaged = this.returnIsPaged;
    json.ServiceUrl = this.serviceUrl;
    json.ServiceName = this.serviceName;
    json.Action = this.action;
    json.EnableDistributeTransaction = this.enableDistributeTransaction;
    json.DTPType = this.dTPType;
    json.HttpMethod = this.httpMethod;
    json.NetworkProtocol = this.networkProtocol;
    json.Component_ID = this.component_ID;
    if (this.serviceActions && this.serviceActions.length > 0) {
      json.ServiceActions = [];
      this.serviceActions.forEach((element) => {
        json.ServiceActions.push(element.toJson());
      });
    }
    if (this.parameters && this.parameters.length > 0) {
      json.Parameters = [];
      this.parameters.forEach((element) => {
        json.Parameters.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('返回值', 'returnDataType', '返回数据类型', EnumDataType.Reference, this.returnDataType, true, '返回数据类型，无返回使用void', 'EnumDataType', 'PGRowEnumValue');
    context.addRow('返回值', 'returnReferenceType', '返回引用类型', EnumDataType.String, this.returnReferenceType, true, '返回值引用类型，当数据类型为引用类型时有效', '', 'PGRowDataTypeValue:all');
    context.addRow('返回值', 'returnDescription', '返回值描述', EnumDataType.String, this.returnDescription, true, '返回值描述', '', '');
    context.addRow('返回值', 'returnIsCollection', '是否是集合', EnumDataType.Bool, this.returnIsCollection, true, '返回值是否是集合', '', '');
    context.addRow('返回值', 'returnIsPaged', '是否分页', EnumDataType.Bool, this.returnIsPaged, true, '返回值是否是否分页', '', '');
    context.addRow('微服务', 'serviceUrl', '服务地址', EnumDataType.String, this.serviceUrl, true, '不含协议名，域名以及微服务名称，也不含操作名称 。', '', '');
    context.addRow('微服务', 'serviceName', '服务名称', EnumDataType.String, this.serviceName, true, '微服务注册的服务名称，模型使用应用名', '', '');
    context.addRow('微服务', 'action', '方法', EnumDataType.String, this.action, true, '服务的方法', '', '');
    context.addRow('事务', 'enableDistributeTransaction', '支持分布式事务', EnumDataType.Bool, this.enableDistributeTransaction, true, '是否支持分布式事务', '', '');
    context.addRow('事务', 'dTPType', '分布式事务协议', EnumDataType.Reference, this.dTPType, true, '分布式事务协议', 'EnumDTPType', 'PGRowEnumValue');
    context.addRow('服务', 'httpMethod', 'HTTP谓词', EnumDataType.Reference, this.httpMethod, true, '调用外部服务时的HTTP谓词', 'EnumHTTPMethod', 'PGRowEnumValue');
    context.addRow('服务', 'networkProtocol', '网络协议', EnumDataType.Reference, this.networkProtocol, true, '调用外部服务时的网络协议', 'EnumNetworkProtocol', 'PGRowEnumValue');
    return context;
  }

  static Create(json: any): BEExternalService {
    const bEExternalService = new BEExternalService();
    bEExternalService.Deserialize(json);
    bEExternalService.json = json;
    return bEExternalService;
  }
}
